import React, { useState } from "react";
import firebase from "../firebase";
import "./feedback.css";

const Feedback = (props) => {
  document.title =
    "Webinar Feedback Form | Digital Technology in Present Scenario";
  const [values, setValues] = useState({
    name: props.user.name,
    coll: props.user.coll,
    state: props.user.state,
    mobile: props.user.mobile,
    dege: props.user.dege,
    rate: "",
    help: "",
    sugg: "",
  });
  const changeVal = (e) => {
    var { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };
  const addFeed = (e) => {
    e.preventDefault();
    firebase
      .firestore()
      .collection("feedback")
      .doc(`${props.user.sec}`)
      .set(values)
      .then(() => {
        props.setFeedback(false);
        window.location.href = "https://gmnc.netlify.app/";
      });
  };
  return (
    <div className="form">
      <div>
        <h1>Webinar Feedback Form</h1>
        <form onSubmit={addFeed}>
          <input type="hidden" value={values.dege} name="dege" />
          <label htmlFor="name">Full Name</label>
          <br />
          <input
            className="form-control"
            value={props.user.name}
            id="name"
            name="name"
            readOnly
          />
          <br />
          <label htmlFor="coll">College/ Institute Name</label>
          <br />
          <input
            className="form-control"
            value={props.user.coll}
            id="coll"
            name="coll"
            readOnly
          />
          <br />
          <label htmlFor="state">State</label>
          <br />
          <input
            className="form-control"
            value={props.user.state}
            id="state"
            name="state"
            readOnly
          />
          <br />
          <label htmlFor="mobile">Mobile</label>
          <br />
          <input
            className="form-control"
            value={props.user.mobile}
            id="mobile"
            name="mobile"
            readOnly
          />
          <p>
            <b>Rate this Training Programme</b>
          </p>
          <input
            type="radio"
            id="1"
            name="rate"
            value="1"
            onChange={changeVal}
            required
          />
          <label htmlFor="1">
            1 <i>- Poor</i>
          </label>
          <br />
          <input
            type="radio"
            id="2"
            name="rate"
            value="2"
            onChange={changeVal}
            required
          />
          <label htmlFor="2">2</label>
          <br />
          <input
            type="radio"
            id="3"
            name="rate"
            value="3"
            onChange={changeVal}
            required
          />
          <label htmlFor="3">3</label>
          <br />
          <input
            type="radio"
            id="4"
            name="rate"
            value="4"
            onChange={changeVal}
            required
          />
          <label htmlFor="4">4</label>
          <br />
          <input
            type="radio"
            id="5"
            name="rate"
            value="5"
            onChange={changeVal}
            required
          />
          <label htmlFor="5">
            5 <i>- Extremely Excellent</i>
          </label>
          <p>
            <b>How helpful was the training for you</b>
          </p>
          <input
            type="radio"
            id="h1"
            name="help"
            value="Extremly helpful"
            required
            onChange={changeVal}
          />
          <label htmlFor="h1">Extremly helpful</label>
          <br />
          <input
            type="radio"
            id="h2"
            name="help"
            value="Very Helpful"
            required
            onChange={changeVal}
          />
          <label htmlFor="h2">Very Helpful</label>
          <br />
          <input
            type="radio"
            id="h3"
            name="help"
            value="Somewhat helpful"
            required
            onChange={changeVal}
          />
          <label htmlFor="h3">Somewhat helpful</label>
          <br />
          <input
            type="radio"
            id="h4"
            name="help"
            value="Not so helpful"
            required
            onChange={changeVal}
          />
          <label htmlFor="h4">Not so helpful</label>
          <br />
          <br />
          <label htmlFor="sugg">Any Suggestions</label>
          <br />
          <input
            id="sugg"
            className="form-control"
            type="text"
            name="sugg"
            onChange={changeVal}
            placeholder="Any Suggestion"
          />
          <br />
          <br />
          <button className="submit">Send Feedback</button>
        </form>
      </div>
    </div>
  );
};

export default Feedback;
